'use client';
import { useAllSettingsShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/shortcuts/useAllSettingsShortcut.js';
import { useDictationShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/shortcuts/useDictationShortcut.js';
import { useFocusAskInputShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/shortcuts/useFocusAskInputShortcut.js';
import { useNewThreadShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/shortcuts/useNewThreadShortcut.js';
import { useOpenCommandPaletteShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/shortcuts/useOpenCommandPaletteShortcut.js';
import { useShowShortcutsShortcut } from '#pplx/frontend/apps/ask/keyboard-shortcuts-builtins/shortcuts/useShowShortcutsShortcut.js';
import React from 'react';
/**
 * Registers the built-in global shortcuts (new thread, show shortcuts,
 * focus ask input, command palette, dictation, all settings).
 * Must be rendered as a child of `KeyboardShortcutsProvider`.
 *
 * Separated from the provider so that lightweight entry points (e.g.
 * `spa-aux` for auth/login/signup) can use the shortcut registry without
 * pulling in heavy context dependencies like `QueryInputStateProvider`.
 *
 * Built-in shortcuts are registered first and sit at the bottom of the
 * stack with the lowest priority — page-specific overrides take precedence.
 */
export const BuiltInShortcuts = () => {
    useNewThreadShortcut();
    useShowShortcutsShortcut();
    useFocusAskInputShortcut();
    useOpenCommandPaletteShortcut();
    useDictationShortcut();
    useAllSettingsShortcut();
    return null;
};
//# sourceMappingURL=BuiltInShortcuts.js.map